/*==================================================
  CUSTOM IMAGE BANNER – SLIDER JS
==================================================*/

(function () {
  "use strict";

  document.querySelectorAll(".custom-banner").forEach(function (banner) {

    /*==============================================
      ELEMENTS
    ==============================================*/

    const track       = banner.querySelector(".custom-banner__track");
    const slides      = Array.from(banner.querySelectorAll(".custom-banner__slide"));
    const dots        = Array.from(banner.querySelectorAll(".custom-banner__dot"));
    const prevBtn     = banner.querySelector(".custom-banner__arrow--prev");
    const nextBtn     = banner.querySelector(".custom-banner__arrow--next");
    const progressBar = banner.querySelector(".custom-banner__progress-bar");

    const total = slides.length;

    // Stop if only 1 or no slides
    if (total <= 1) return;

    /*==============================================
      SETTINGS – read from data attributes
    ==============================================*/

    const speedSec   = parseFloat(banner.dataset.autoplaySpeed) || 5;
    const speedMs    = speedSec * 1000;
    const transition = banner.dataset.transition || "fade"; // "fade" | "slide"

    /*==============================================
      STATE
    ==============================================*/

    let current  = 0;
    let timer    = null;
    let isPaused = false;

    /*==============================================
      SLIDE MODE SETUP
      Sets track & slide widths for horizontal
      sliding transition
    ==============================================*/

    function initSlideMode() {
      track.style.display = "flex";
      track.style.width   = total * 100 + "%";

      slides.forEach(function (slide) {
        slide.style.width = (100 / total) + "%";
      });
    }

    if (transition === "slide") {
      initSlideMode();
    }

    /*==============================================
      CONTENT SELECTORS
      Used to reset animations on inactive slides
    ==============================================*/

    const CONTENT_SELECTORS = [
      ".custom-banner__subtitle",
      ".custom-banner__title",
      ".custom-banner__description",
      ".custom-banner__button"
    ].join(",");

    /*==============================================
      RESET SLIDE CONTENT
      Snaps content back to hidden state so the
      animation replays fresh next time the slide
      becomes active
    ==============================================*/

    function resetSlideContent(slide) {
      slide.querySelectorAll(CONTENT_SELECTORS).forEach(function (el) {

        // Disable transition so the reset is invisible
        el.style.transition = "none";
        el.style.opacity    = "0";
        el.style.transform  = "translateY(24px)";

        // Re-enable transition on next frame
        requestAnimationFrame(function () {
          el.style.transition = "";
          el.style.opacity    = "";
          el.style.transform  = "";
        });

      });
    }

    /*==============================================
      GO TO SLIDE
    ==============================================*/

    function goTo(index) {

      if (index === current) return;

      const prev = current;
      current    = (index + total) % total;

      // ── Deactivate outgoing slide ─────────────

      slides[prev].classList.remove("is-active");
      slides[prev].setAttribute("aria-hidden", "true");

      // Reset outgoing slide content after
      // the transition finishes (invisible snap-back)
      const resetDelay = transition === "fade" ? 300 : 750;

      setTimeout(function () {
        resetSlideContent(slides[prev]);
      }, resetDelay);

      // ── Activate incoming slide ───────────────

      slides[current].classList.add("is-active");
      slides[current].setAttribute("aria-hidden", "false");

      // ── Move track (slide mode only) ─────────

      if (transition === "slide") {
        track.style.transform =
          "translateX(-" + (current * (100 / total)) + "%)";
      }

      // ── Update dots ───────────────────────────

      dots.forEach(function (dot, i) {
        dot.classList.toggle("is-active", i === current);
      });

      // ── Restart progress bar ──────────────────

      resetProgress();

    }

    /*==============================================
      NEXT & PREV HELPERS
    ==============================================*/

    function next() {
      goTo(current + 1);
    }

    function prev() {
      goTo(current - 1);
    }

    /*==============================================
      AUTOPLAY
    ==============================================*/

    function startAutoplay() {
      clearInterval(timer);
      timer = setInterval(next, speedMs);
    }

    function stopAutoplay() {
      clearInterval(timer);
    }

    /*==============================================
      PROGRESS BAR
    ==============================================*/

    function resetProgress() {

      if (!progressBar) return;

      // Reset to 0 instantly
      progressBar.style.transition = "none";
      progressBar.style.width      = "0%";

      // Force reflow so the transition restart works
      progressBar.getBoundingClientRect();

      // Animate to 100% over the full slide duration
      progressBar.style.transition = "width " + speedSec + "s linear";
      progressBar.style.width      = "100%";

    }

    /*==============================================
      ARROW BUTTONS
    ==============================================*/

    if (prevBtn) {
      prevBtn.addEventListener("click", function () {
        prev();
        stopAutoplay();
        startAutoplay();
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener("click", function () {
        next();
        stopAutoplay();
        startAutoplay();
      });
    }

    /*==============================================
      DOT BUTTONS
    ==============================================*/

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function () {
        goTo(i);
        stopAutoplay();
        startAutoplay();
      });
    });

    /*==============================================
      PAUSE ON HOVER
      Freezes the progress bar at its current
      position while the user hovers
    ==============================================*/

    banner.addEventListener("mouseenter", function () {

      isPaused = true;
      stopAutoplay();

      if (progressBar) {
        const computed    = getComputedStyle(progressBar).width;
        const parentWidth = progressBar.parentElement.offsetWidth;
        const pct         = (parseFloat(computed) / parentWidth) * 100;

        progressBar.style.transition = "none";
        progressBar.style.width      = pct + "%";
      }

    });

    banner.addEventListener("mouseleave", function () {

      isPaused = false;

      if (progressBar) {

        // Calculate how much time remains based on
        // the current progress bar width
        const computed    = getComputedStyle(progressBar).width;
        const parentWidth = progressBar.parentElement.offsetWidth;
        const pct         = parseFloat(computed) / parentWidth; // 0 → 1
        const remaining   = speedSec * (1 - pct);

        // Resume bar from current position
        progressBar.style.transition = "width " + remaining + "s linear";
        progressBar.style.width      = "100%";

        // Fire next slide after remaining time
        stopAutoplay();
        timer = setTimeout(function () {
          next();
          startAutoplay();
        }, remaining * 1000);

      } else {
        startAutoplay();
      }

    });

    /*==============================================
      TOUCH / SWIPE SUPPORT
      Swipe left  → next slide
      Swipe right → prev slide
    ==============================================*/

    let touchStartX = 0;

    banner.addEventListener("touchstart", function (e) {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    banner.addEventListener("touchend", function (e) {

      const diff = touchStartX - e.changedTouches[0].screenX;

      // Only trigger if swipe is more than 50px
      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          next(); // Swipe left  → next
        } else {
          prev(); // Swipe right → prev
        }
        stopAutoplay();
        startAutoplay();
      }

    }, { passive: true });

    /*==============================================
      KEYBOARD SUPPORT
      Arrow Left  → prev slide
      Arrow Right → next slide
    ==============================================*/

    banner.setAttribute("tabindex", "0");

    banner.addEventListener("keydown", function (e) {

      if (e.key === "ArrowLeft") {
        prev();
        stopAutoplay();
        startAutoplay();
      }

      if (e.key === "ArrowRight") {
        next();
        stopAutoplay();
        startAutoplay();
      }

    });

    /*==============================================
      INITIALISE
    ==============================================*/

    // Ensure only slide 0 is active on load
    slides.forEach(function (slide, i) {
      if (i !== 0) slide.classList.remove("is-active");
    });

    slides[0].classList.add("is-active");
    slides[0].setAttribute("aria-hidden", "false");

    resetProgress();
    startAutoplay();

  }); // end forEach banner

})();